import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { FlexRow, FlexColumn } from 'ui-components/components/flex';
import { InfoIcon } from 'ui-components/components/info-icon';
import { Text, TextType } from 'ui-components/components/text';

import styles from './styles.module.less';
import { INSURANCE_WALLET_TOGGLE } from '../../../../../constants/analytics-events';
import { getInsuranceProviderById } from '../../../../../enums/insurance-providers';
import { InsuranceTermsLink } from '../../../../../insurance/terms-link';
import { useTrackInsuranceEvent } from '../../../../../insurance/hooks/use-track-insurance-event';
import { EventSourceStrings } from '../../../../../tracking/tracking-constants';
import { messages } from '../../../../messages';
import { useWalletRegistrationModalContext } from '../../contexts/wallet-registration-modal-context';

export const ApplyInsuranceCheckbox = () => {
  const intl = useIntl();
  const { walletToRegister, shouldAutoInsure, setShouldAutoInsure, shouldShowInsuranceToggle } = useWalletRegistrationModalContext();
  const { newInsuranceProviderIds = [] } = walletToRegister;
  const trackWalletToggle = useTrackInsuranceEvent(INSURANCE_WALLET_TOGGLE, EventSourceStrings.ADD_FUNDS_WALLET_REGISTRATION_STEP);
  const hasWalletedInsurance = newInsuranceProviderIds.length > 0;
  if (!hasWalletedInsurance || !shouldShowInsuranceToggle) {
    return false;
  }
  const insuranceProvider = getInsuranceProviderById(newInsuranceProviderIds[0]);
  const insuranceTooltipText = intl.formatMessage(messages.autoInsureDisclaimer);
  return (
    <FlexColumn className={styles['insurance-section']}>
      <FlexRow className={styles['insurance-checkbox-row']}>
        <Checkbox
          checked={shouldAutoInsure}
          className={styles['include-insurance']}
          label={<FormattedMessage {...messages.includeInsuranceLabel} />}
          onChange={() => {
            setShouldAutoInsure((prev) => {
              const next = !prev;
              trackWalletToggle({ insuranceProvider: insuranceProvider?.name, toggleValue: next });
              return next;
            });
          }}
        />
        <InfoIcon className={styles['add-fund-icon']} size='small' tooltipText={insuranceTooltipText} />
      </FlexRow>
      <Text
        className={styles['auto-insure-disclaimer']}
        formattedMessageValues={{
          a: (chunks) => (
            <InsuranceTermsLink
              insuranceProviderId={newInsuranceProviderIds[0]}
              source={EventSourceStrings.ADD_FUNDS_WALLET_REGISTRATION_STEP}
            >
              {chunks}
            </InsuranceTermsLink>
          ),
        }}
        textType={TextType.Caption}
        value={messages.autoInsureDisclaimer2}
      />
    </FlexColumn>
  );
};
